import React from "react";
import { selectors as notificationSelectors, actions as notificationActions } from "reducers/notification";
import { connect } from "react-redux";
import { arrayOf, bool, element, func, number, string, shape } from "prop-types";
import NotificationSystem from "react-notification-system";
import { i18nIdWithError, i18nIdWithConfirm, i18nIdWithAttention } from "util/notification";
import * as i18n from "util/i18n";

/*
Por customizacion ver, ver: https://github.com/igorprado/react-notification-system
*/
class Notification extends React.Component {
    static propTypes = {
        scopeToShow: string.isRequired, // what scope this notification component must listen
        message: string,
        scopes: arrayOf(element).isRequired,
        dispatch: func.isRequired,
        level: string,
        errors: shape({}),
        metadata: shape({
            idForm: string.isRequired,
            version: number,
            enabled: bool,
            category: string.isRequired,
            type: string.isRequired,
            adminOption: string.isRequired,
            idActivity: string.isRequired,
            fieldList: arrayOf(
                shape({
                    idField: string.isRequired,
                    labelMap: shape({}).isRequired,
                    requiredErrorMap: shape({}).isRequired,
                }),
            ).isRequired,
        }),
        currentLang: string,
        autoDismiss: string,
    };

    static defaultProps = {
        message: "",
        level: "",
        currentLang: "",
        metadata: null,
        errors: {},
        autoDismiss: "5",
    };

    state = {
        notificationSystem: null,
    };

    componentDidMount() {
        // eslint-disable-next-line react/no-string-refs
        const { notificationSystem } = this.refs;

        this.setState({ notificationSystem });
    }

    componentDidUpdate() {
        const { message, scopes, scopeToShow } = this.props;

        if (message && scopes && scopes.indexOf(scopeToShow) !== -1) {
            this.addNotification();
        }
    }

    addNotification = () => {
        const { notificationSystem } = this.state;
        const { dispatch, message, level, errors, metadata, currentLang, autoDismiss } = this.props;

        let allFormFieldsInfo;
        let errorFieldsKeys;
        let errorFieldsInfo;

        if (metadata) {
            allFormFieldsInfo = metadata.fieldList;
            errorFieldsKeys = Object.keys(errors);
            errorFieldsInfo = allFormFieldsInfo.filter((field) => errorFieldsKeys.includes(field.idField));
        }

        const withParams = message.includes("withParams");
        const msj = withParams ? JSON.parse(message) : message;

        const selectFontWeight = (_message) => {
            const i18nId = withParams ? _message.id : _message;
            if (i18nIdWithError.includes(i18nId)) {
                return "notifications.error";
            }
            if (i18nIdWithConfirm.includes(i18nId)) {
                return "notifications.confirm";
            }
            if (i18nIdWithAttention.includes(i18nId)) {
                return "notifications.attention";
            }
            return null;
        };

        const labelWithfontWeight = selectFontWeight(msj);

        const finalMessage = (
            <>
                <span style={{ fontWeight: 700 }}>{`${i18n.get(labelWithfontWeight)} `}</span>
                {withParams ? (
                    <span>{`${i18n.get(msj.id, null, msj.params)}`}</span>
                ) : (
                    <span>{`${i18n.get(message)}`}</span>
                )}
            </>
        );

        const msgHTML = <div dangerouslySetInnerHTML={{ __html: message }} className="message-body" />;

        notificationSystem.clearNotifications();
        notificationSystem.addNotification({
            message: labelWithfontWeight ? finalMessage : msgHTML,
            level,
            position: "tc",
            autoDismiss,
            dismissible: true,
            children: (
                <div className="visually-hidden">
                    {errorFieldsInfo &&
                        errorFieldsInfo.map((field) => (
                            <div>{`${field.labelMap[currentLang]} : ${field.requiredErrorMap[currentLang]}`}</div>
                        ))}
                </div>
            ),
        });

        dispatch(notificationActions.removeNotification());
    };

    render() {
        // ignoring warning because the only way to remove all the styles from the component is to pass style as false
        return (
            <div aria-live="polite">
                <NotificationSystem
                    // eslint-disable-next-line react/no-string-refs
                    ref="notificationSystem"
                    // eslint-disable-next-line react/style-prop-object
                    style={false}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    message: notificationSelectors.getMessage(state),
    level: notificationSelectors.getLevel(state),
    scopes: notificationSelectors.getScopes(state),
});

export default connect(mapStateToProps)(Notification);
